import axios from 'axios'
import { useAuthStore } from '~/player/stores/auth'
import router from '~/player/router'

const api = axios.create({
  baseURL: '/api/player',
  headers: { 'Content-Type': 'application/json' }
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('player_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('player_token')
      const auth = useAuthStore()
      auth.clear()
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

export default api
